import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import WOW from "wowjs";
import "animate.css";
import { API } from "../../constants";

const Toprestaurants = () => {
    const [restaurants, setRestaurants] = useState([]);

    useEffect(() => {
        new WOW.WOW({ live: false }).init();
    }, []);

    useEffect(() => {
        const fetchRestaurants = async () => {
            try {
                const response = await fetch(API.ALL_RESTAURENTS);
                const data = await response.json();
                if (data.status === 1 && Array.isArray(data.restaurants)) {
                    setRestaurants(data.restaurants);
                }
            } catch (error) {
                console.error("Failed to fetch restaurants:", error);
            }
        };

        fetchRestaurants();
    }, []);

    return (
        <section className="top-rest-area cmn-gap">
            <Container>
                <div className="title-inner">
                    <div className="subheading">Website for Restaurant and Cafe</div>
                    <h2>Top Restaurants</h2>
                    <p>Things that get tricky are things like burgers and fries, or things that are deep-fried. We do have a couple of burger restaurants that are capable of doing a good job transporting but fries are almost impossible.</p>
                </div>
                <div className="top-restaurants-wrapper">
                    <Row className="restaurants-wrapper style2 g-4">
                        {restaurants.map((restaurant, index) => (
                            <Col key={restaurant._id} md={3} lg={2} sm={6}
                                className="wow animate__bounceIn"
                                data-wow-delay={`${0.1 * (index + 1)}s`}>
                                <div className="top-restaurant">
                                    <Link to={`/restaurant-view/${restaurant._id}`}>
                                        <img
                                            src={restaurant.restaurent_image}
                                            alt={restaurant.restaurant_name}
                                            style={{ width: '100%', height: 'auto' }}
                                        />
                                    </Link>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
                <div className="btn-wrap mt-5 text-center">
                    <Link to="/restaurants" className="cmn-btn">View All</Link>
                </div>
            </Container>
        </section>
    );
};

export default Toprestaurants;
